import { component } from 'knockout-decorators'

import source from './search-empty-state.html?raw'

export interface SearchEmptyStateParams {
  i18nKey?: string
}

@component('search-empty-state', source)
export class SearchEmptyState {
  public i18nKey: string

  constructor(params: SearchEmptyStateParams = {}) {
    this.i18nKey = params.i18nKey ?? 'noSearchResults'
  }
}
